import { Box, Typography, useTheme } from '@mui/material';
import { useCountdown } from 'hooks';
import { padWithLeadingZeros } from 'utils';

interface Props {
    countdownSeconds: number;
    onTimeout: () => void;
}

export const CountdownClock = (props: Props) => {
    const theme = useTheme()
    const { remainingSeconds, remainingProgress } = useCountdown(props.countdownSeconds, props.onTimeout, 1000);
    if (!props.countdownSeconds) {
        return null;
    }

    const showHours = props.countdownSeconds > 60 * 60;
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds - minutes * 60;
    const hours = Math.floor(minutes / 60);

    const getProgressColor = (progress: number): string => {
        if (progress > 75) {
            return theme.palette.success.main;
        }
        if (progress > 50) {
            return theme.palette.info.main;
        }
        if (progress > 25) {
            return theme.palette.warning.main;
        }
        return theme.palette.error.main;
    };

    const separator = (
        <Typography variant="h5" fontWeight="bold" sx={{ margin: '0 5px' }}>
            :
        </Typography>
    );

    return (
        <Box display="flex" alignItems="center" color={getProgressColor(remainingProgress)}>
            {showHours && (
                <>
                    <Typography variant="h5" fontWeight="bold">
                        {padWithLeadingZeros(hours)}
                    </Typography>
                    {separator}
                </>
            )}
            <Typography variant="h5" fontWeight="bold">
                {padWithLeadingZeros(minutes)}
            </Typography>
            {separator}
            <Typography variant="h5" fontWeight="bold">
                {padWithLeadingZeros(seconds)}
            </Typography>
        </Box>
    );
};
